import React, { useState, useEffect } from 'react';
import './App.scss';
import { Helmet } from 'react-helmet';
import Navbar from './Components/navbar';
import HeroSection from './Components/homeSection';
import AboutSection from './Components/StoryPage';
import StackSection from './Components/SkillPage';
import CertificationsSection from './Components/CertificationsSection';
import ProjectsSection from './Components/ProjetSection';
import ContactSection from './Components/ContactSection';
import Footer from './Components/FooterSection';

function App() {
  const [activeSection, setActiveSection] = useState('home');

  // Track active section on scroll
  useEffect(() => {
    const sections = ['home', 'about', 'stack', 'certifications', 'projects', 'contact'];

    const handleScroll = () => {
      const scrollY = window.scrollY + 200;

      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && el.offsetTop <= scrollY) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="app">
      <Helmet htmlAttributes={{ lang: 'fr' }}>
        <title>Dimitri Bonsou | Développeur Fullstack & Product Builder</title>
        <meta
          name="description"
          content="Développeur Fullstack & Product Builder spécialisé en architecture logicielle et DevOps. Recherche d'un stage de 6 mois dès Février 2027."
        />
        <meta
          name="keywords"
          content="développeur fullstack, product builder, AI-augmented developer, Claude Code, Codex, React, TypeScript, Spring Boot, DevOps, architecture logicielle, France"
        />
        <meta
          property="og:title"
          content="Dimitri Bonsou | Développeur Fullstack & Product Builder"
        />
        <meta
          property="og:description"
          content="Développeur Fullstack · Architecture · DevOps · Product Builder. Solutions complexes livrées avec l'aide de Claude Code et Codex."
        />
        <meta property="og:url" content="https://dimidevofficiel.vercel.app" />
        <meta
          name="google-site-verification"
          content="C5ftg5VXj5bdp7FA8aBYQZt-xwKjbTg4xNj8wQyzUZM"
        />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="anonymous"
        />
      </Helmet>

      <Navbar activeSection={activeSection} />

      <main className="main-content">
        <HeroSection />
        <AboutSection />
        <StackSection />
        <CertificationsSection />
        <ProjectsSection />
        <ContactSection />
      </main>

      <Footer />
    </div>
  );
}

export default App;
